import _comment from "./nodes/comment";
import _html from "./nodes/html";
import _node from "./nodes/node";
import _text from "./nodes/text";
import _type from "./nodes/type";
import _parse from "./parse";
import _valid from "./valid";
var exports = {};
var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NodeType = exports.TextNode = exports.Node = exports.valid = exports.CommentNode = exports.HTMLElement = exports.parse = void 0;
var comment_1 = __importDefault(_comment);
exports.CommentNode = comment_1.default;
var html_1 = __importDefault(_html);
exports.HTMLElement = html_1.default;
var node_1 = __importDefault(_node);
exports.Node = node_1.default;
var text_1 = __importDefault(_text);
exports.TextNode = text_1.default;
var type_1 = __importDefault(_type);
exports.NodeType = type_1.default;
var parse_1 = __importDefault(_parse);
var valid_1 = __importDefault(_valid);
exports.valid = valid_1.default;
function parse(data, options) {
  if (options === void 0) {
    options = {};
  }
  return (0, parse_1.default)(data, options);
}
exports.default = parse;
exports.parse = parse;
parse.parse = parse_1.default;
parse.HTMLElement = html_1.default;
parse.CommentNode = comment_1.default;
parse.valid = valid_1.default;
parse.Node = node_1.default;
parse.TextNode = text_1.default;
parse.NodeType = type_1.default;
export default exports;
export const __esModule = exports.__esModule,
  NodeType = exports.NodeType,
  TextNode = exports.TextNode,
  Node = exports.Node,
  valid = exports.valid,
  CommentNode = exports.CommentNode,
  HTMLElement = exports.HTMLElement;
const _parse2 = exports.parse;
export { _parse2 as parse };